import { render } from "./SectionTransition.vue?vue&type=template&id=050632ac"
import script from "./SectionTransition.vue?vue&type=script&lang=js"
export * from "./SectionTransition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__